<mat-card class="banner" appearance="raised">
  <mat-card-content class="banner-content">
    @if (fontIcon()) {
      <mat-icon class="help-icon" [fontIcon]="fontIcon()" />
    }
    <div>
      <ng-content />
    </div>
  </mat-card-content>
</mat-card>
